import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import { useParams, useHistory } from 'react-router-dom';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import Appointments from './Appointments';
import api from '../../../api/api';
import { notificationsAtom } from '../../../atoms/Atoms';
import Installations from './Installations';

function Calendar() {
  const { orgReferralCode } = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const [organization, setOrganization] = useState(null);
  const [loadingOrganization, setLoadingOrganization] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);

  function getOrganization() {
    setLoadingOrganization(true);
    api.get(`organizations?rc=${orgReferralCode}`)
      .then((response) => {
        setLoadingOrganization(false);
        if (response?.data?.success) {
          if (response.data.data) {
            setOrganization(response.data.data);
          } else {
            setNotifications([
              ...notifications,
              {
                title: t('error'),
                description: t('organization_was_not_found'),
                error: true,
              },
            ]);
            history.push('/admin');                
          }
        } else {
          setOrganization(null);
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: t('organization_was_not_found'),
              error: true,
            },
          ]);
          history.push('/admin');
        }
      })
      .catch((error) => {
        setLoadingOrganization(false);
        history.push('/admin');
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: t('organization_was_not_found'),
            error: true,
          },
        ]);
      });
  }
  
  useEffect(() => {
    if (orgReferralCode) {
      getOrganization();
    }
  }, [orgReferralCode]);
  
  return (
    <MainPage includeBack>
      <H1 text={organization ? `${organization?.nameEn} - ${t('calendar')}` : t('global_calendar')} />
      <Tabs>
        <Tabs.TabPane key="1" tab={t('appointments')}>
          <Appointments />
        </Tabs.TabPane>
        <Tabs.TabPane key="2" tab={`${t('installations')} (${t('scheduled')})`}>
          <Installations />
        </Tabs.TabPane>
      </Tabs>
    </MainPage>
  );
}

export default Calendar;
